// src/components/Servicios.js
import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../layouts/Servicios.css";

import Titulo from "../assets/pc/Somos/tit1.png";
import texto1 from "../assets/pc/Somos/texto_1.png";
import texto2 from "../assets/pc/Somos/texto_2.png";
import texto3 from "../assets/pc/Somos/texto_3.png";
import texto4 from "../assets/pc/Somos/texto_4.png";

import Titulom from "../assets/celu/Somos/Tit_1.png"
import texto1m from "../assets/celu/Somos/Texto_1.png";
import texto2m from "../assets/celu/Somos/texto_2.png";
import texto3m from "../assets/celu/Somos/texto_3.png";
import texto4m from "../assets/celu/Somos/texto_4.png";

export default function Servicios() {
  const isMobile = window.innerWidth < 768;
  const slides = isMobile
    ? [texto1m, texto2m, texto3m, texto4m]
    : [texto1, texto2, texto3, texto4];
	let Titulox = Titulo
	if (isMobile) Titulox = Titulom
  const settings = {
    dots: true,
    dotsClass: "slick-dots custom-dots",
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    color: "#fff",
    autoplay: true,
    autoplaySpeed: 4000,
  };

  return (
    <section className="servicio-section">
      <div className="servicio-container">
        <div className="servicio-spacer" />
        <div className="slider-wrapper">
          <img className="servicio-title" src={Titulox} alt="Título servicio" />
          <Slider {...settings}>
            {slides.map((src, idx) => (
              <div key={idx} className="slide-item">
                <img style={{width:isMobile? "100%": "60%"}} src={src} alt={`Slide ${idx + 1}`} />
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
}
